export default "__VITE_ASSET__CHH3sTCj__"